import angular from 'angular';
import _ from 'lodash';
import ModelUpdateNotAllowedModal from '../../modals/model-update-not-allowed.data';

class OrderParamCtrl {
    /* @ngInject */
    constructor(
        $location,
        $state,
        $scope,
        logger,
        $uibModal,
        $translate,
        OrderParamSvc,
        AuthSvc,
        ORDER_PARAM,
        PrincipalSvc,
        CommunitySvc
    ) {
        this.$location = $location;
        this.$state = $state;
        this.$scope = $scope;
        this.logger = logger;
        this.$uibModal = $uibModal;
        this.$translate = $translate;
        this.OrderParamSvc = OrderParamSvc;
        this.AuthSvc = AuthSvc;
        this.ORDER_PARAM = ORDER_PARAM;
        this.PrincipalSvc = PrincipalSvc;
        this.CommunitySvc = CommunitySvc;

        //------------------
        // Sets de controle
        //------------------
        this.unselectStdControlSetMsg = null;
    }

    $onInit() {
        // Template du document
        this.rawDocumentModel = angular.copy(this.documentModel);
        this.attributes = angular.copy(this.attributes);
        this.specificModelName = this.modelContext.eid.concat(
            this.$translate.instant('principal.order_param.' + this.functionalType.toLowerCase() + '_sufixe')
        );
        // pour le module commande on a 2 controlesSets ORDER et CANCELLATION
        if (this.controlSetsCancellation) {
            this.controlSetsCancellation.forEach(ctrSets => {
                this.controlSets.push(ctrSets);
            });
        }

        this.controlSets = this.buildControlSets(this.controlSets);
        this.rawControlSets = angular.copy(this.controlSets);
        this._initData(this.documentModel);
    }

    _initData(documentModel) {
        // indiquer pour chaque attribut sa présence ou non dans le modèle et IHM
        this._fixPresence(documentModel);
        // On sépare les différentes catégories
        this.orderAttributes = this._copyAttributeByCat(documentModel);
    }

    _copyAttributeByCat(documentModel) {
        return {
            seller: documentModel.documentModel.getAttBySection('seller'),
            buyer: documentModel.documentModel.getAttBySection('buyer'),
            header: documentModel.documentModel.getAttBySection('header'),
            response: documentModel.documentModel.getAttBySection('response'),
            line: documentModel.documentModel.getAttBySection('line'),
            reduction: documentModel.documentModel.getAttBySection('reduction'),
            cost: documentModel.documentModel.getAttBySection('cost'),
            total: documentModel.documentModel.getAttBySection('total'),
            packaging: documentModel.documentModel.getAttBySection('packaging'),
            despatch: documentModel.documentModel.getAttBySection('despatch'),
            delivery: documentModel.documentModel.getAttBySection('delivery'),
            technical: documentModel.documentModel.getAttBySection('technical'),
        };
    }

    _fixPresence(documentModel) {
        angular.forEach(documentModel.documentModel.attributes, attribute => {
            angular.forEach(this.ORDER_PARAM.presenceOptions, option => {
                if (option.visible === attribute.visible) {
                    attribute.presence = option;
                }
            });
        });
    }

    buildControlSets(controlSets) {
        var orderControlSets = _.filter(controlSets, controlSet => controlSet.mode === 'ORDER');
        var cancellationControlSets = _.filter(controlSets, controlSet => controlSet.mode === 'CANCELLATION');
        var responseControlSets = _.filter(controlSets, controlSet => controlSet.mode === 'RESPONSE');
        var desadvControlSets = _.filter(controlSets, controlSet => controlSet.mode === 'DESADV');
        var recadvControlSets = _.filter(controlSets, controlSet => controlSet.mode === 'RECADV');
        return {
            orderControlSets: orderControlSets,
            cancellationControlSets: cancellationControlSets,
            responseControlSets: responseControlSets,
            desadvControlSets: desadvControlSets,
            recadvControlSets: recadvControlSets,
        };
    }

    isCommunityContext() {
        return this.modelContext.type === 'community';
    }

    //----------------------------
    // Gestion des champs de la facture
    //----------------------------
    addItem(addedAttributes, section) {
        this.OrderParamSvc.addAttributesToSection(this.orderAttributes[section], addedAttributes);
    }

    removeItem(attribute) {
        _.remove(this.documentModel.attributes, a => a.path === attribute.path && a.section === attribute.section);
    }

    displayDetail() {
        return this.documentModel.specific;
    }

    //------------------------------
    // Gestion des sets de controle
    //------------------------------
    onControlSetChange(set, mode) {
        //vérifier qu'il reste au moins un control set sélectionné
        if (!set.selected) {
            var controlSets = null;
            switch (mode) {
                case 'ORDER':
                    controlSets = this.controlSets.orderControlSets;
                    break;
                case 'CANCELLATION':
                    controlSets = this.controlSets.cancellationControlSets;
                    break;
                case 'RESPONSE':
                    controlSets = this.controlSets.responseControlSets;
                    break;
                case 'DESADV':
                    controlSets = this.controlSets.desadvControlSets;
                    break;
                case 'RECADV':
                    controlSets = this.controlSets.recadvControlSets;
                    break;
                default:
                    break;
            }
            var length = _.filter(controlSets, { selected: true }).length;
            if (length == 0) {
                set.selected = true;
                return;
            }
        }

        if (set.standard && !set.selected) {
            this.unselectStdControlSetMsg = this.$translate.instant(
                this.modelContext.type + '.order_param.modal_control_set',
                {
                    ctrlNameSet: set.label,
                }
            );
            this.$uibModal
                .open({
                    scope: this.$scope,
                    controllerAs: 'vm',
                    templateUrl: require('../../modals/modal-unselect-standard-controlset.html'),
                    size: 'md',
                })
                .result.then(
                    () => {
                        set.selected = true;
                    },
                    () => {}
                );
        }
    }

    cancel() {
        this.documentModel = angular.copy(this.rawDocumentModel);
        this._initData(this.documentModel);
        this.controlSets = angular.copy(this.rawControlSets);
    }

    update() {
        this.saveModelPromise = this.OrderParamSvc.saveDocumentModel(
            this.modelContext.eid,
            this.documentModel,
            this.controlSets,
            this.orderAttributes,
            this.functionalType
        );
        this.saveModelPromise.then(
            data => {
                if (data.missingAttributes && data.missingAttributes.length > 0) {
                    new ModelUpdateNotAllowedModal(this.$uibModal, () => this.cancel()).openModelUpdateNotAllowedModal(
                        data.missingAttributes
                    );
                } else {
                    this.rawDocumentModel = angular.copy(this.documentModel);
                    this.rawControlSets = angular.copy(this.controlSets);
                    this.logger.success('success.update', null, null, {
                        entityName: this._updateSuccessMessage(),
                    });
                    if (this.functionalType === 'ORDER') {
                        if (this.isCommunityContext()) {
                            this.communitySvc.refreshCommunity(this.modelContext.eid);
                        } else {
                            this.modelContext.hasOrder = this.documentModel.documentModelEnable;
                            this.PrincipalSvc.refreshPrincipal(this.modelContext.id, null, null);
                            this.PrincipalSvc.updateMenuConsult();
                        }
                    }
                }
            },
            error => {
                this.logger.error('error.update', error);
            }
        );
    }

    _updateSuccessMessage() {
        return this.$translate.instant('principal.order_param.' + this.functionalType.toLowerCase() + '_model');
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    canSelectedOrder() {
        return this.modelContext.canActivateOrder;
    }

    canDisplaySelection() {
        return this.modelContext.canActivateOrder && this.modelContext.hasOrder;
    }
}

angular.module('app.model').component('orderParam', {
    controller: OrderParamCtrl,
    templateUrl: require('./order-param.html'),
    bindings: {
        documentModel: '<',
        attributes: '<',
        modelContext: '<',
        controlSets: '<',
        controlSetsCancellation: '<',
        sections: '<',
        functionalType: '<',
    },
});

angular.module('app.model').component('responseParam', {
    controller: OrderParamCtrl,
    templateUrl: require('./response-param.html'),
    bindings: {
        documentModel: '<',
        attributes: '<',
        modelContext: '<',
        controlSets: '<',
        sections: '<',
        functionalType: '<',
    },
});

angular.module('app.model').component('desadvParam', {
    controller: OrderParamCtrl,
    templateUrl: require('./desadv-param.html'),
    bindings: {
        documentModel: '<',
        attributes: '<',
        modelContext: '<',
        controlSets: '<',
        sections: '<',
        functionalType: '<',
        principal: '<',
    },
});

angular.module('app.model').component('recadvParam', {
    controller: OrderParamCtrl,
    templateUrl: require('./recadv-param.html'),
    bindings: {
        documentModel: '<', // Le modèle de document du DO
        attributes: '<', // Le dictionnaire du DO
        modelContext: '<',
        controlSets: '<',
        sections: '<',
        functionalType: '<',
    },
});
